import Calendar from "components/calendar/calendar.component";
import Selector from "components/selector/selector.component";
import { Fragment, useContext, useState } from "react";
import Table from "routes/client-view/invoices/components/table/table.component";
import { CalendarContext } from "src/contexts/calendar.context";
import { InvoiceContext } from "src/contexts/invoice.context";
import useTranslate from "src/hooks/use-translate";
import TabToggle from "./components/toggle/toggle.tab.component";
import "./safe-tab.style.scss";

const INTERVALS = {
	day: "Daily",
	month: "Monthly",
	year: "Yearly",
};

const VIEW_TYPES = {
	calendar: "Calendar",
	periodic: "Periodic",
};

const SafeTab = () => {
	const { calendarViewType, setCalendarViewType, selectedDay } = useContext(CalendarContext);
	const { calculateBalanceChange } = useContext(InvoiceContext);
	const t = useTranslate("Invoices");

	const [viewType, setViewType] = useState(VIEW_TYPES.calendar);
	const [editable, setEditable] = useState(false);

	const handleIntervalChange = (name) => {
		setCalendarViewType(name);
	};

	const handleViewTypeChange = (type) => {
		setViewType(type);
	};

	const handleToggle = (value) => {
		setEditable(value);
	};

	const startingBalance = 1000;

	return (
		<div className="safe-tab-container">
			<div className="top-left">
				<div className="flex flex--space-between-content border smooth-corners padding-xs--block padding-m--inline size400">
					<p className="w600">Client Safe Plan</p>
					<p>6-Month Safe Period</p>
				</div>
			</div>
			<div className="top-right flex flex--center-items gap-m">
				<button
					onClick={() => handleViewTypeChange(VIEW_TYPES.calendar)}
					className={`border smooth-corners padding-xs--block padding-m--inline size400 w600 ${
						viewType === VIEW_TYPES.calendar && "selected_view_type"
					}`}
				>
					Calendar
				</button>
				<button
					onClick={() => handleViewTypeChange(VIEW_TYPES.periodic)}
					className={`border smooth-corners padding-xs--block padding-m--inline size400 w600 ${
						viewType === VIEW_TYPES.periodic && "selected_view_type"
					}`}
				>
					Periodic
				</button>
				{viewType === VIEW_TYPES.calendar && (
					<div className="flex flex--grow flex--end-content">
						<TabToggle value={editable} onClick={handleToggle} />
					</div>
				)}
			</div>
			{viewType === VIEW_TYPES.calendar && (
				<Fragment>
					<div className="bottom-left padding-m--right">
						<Calendar />
						<div className="data-wrapper with-line margin-m--bottom">
							<div className="sub-text">
								<span className="sub-title">Form Reference:</span>{" "}
								<span className="info">62d6a86ac2cb3</span>
							</div>
						</div>
						<div className="print-wrapper">
							<div className="sub-text">
								<div className="sub-title with-line">Select Format</div>
								<div className="line" />
							</div>
							<div className="button-wrapper">
								<button>PDF</button>
								<button>Excel</button>
							</div>
						</div>
					</div>
					<div className="bottom-right">
						<div className="header">
							<div className="line" />
							<div className="text unselectable">
								<span className="bold">10 {t("days")} </span>
								{t("left for your safe to be locked")}
							</div>
							<div className="line" />

							<div className="button-wrapper">
								{Object.keys(INTERVALS).map((_interval) => {
									return (
										<button
											key={_interval}
											onClick={() => handleIntervalChange(_interval)}
											className={`button unselectable ${
												_interval === calendarViewType && "selected"
											}`}
										>
											{INTERVALS[_interval]}
										</button>
									);
								})}
							</div>
						</div>
						<div className="table-wrapper">
							<Table editable={editable} />
						</div>
					</div>
				</Fragment>
			)}
			{viewType === VIEW_TYPES.periodic && (
				<div
					style={{ width: "100%", gridColumn: "1/-1" }}
					className="flex flex--space-between-content gap-xxxl"
				>
					<div className="flex--grow w600">
						<p className="with-line margin-m--bottom">Select Period</p>
						<Selector data={[1, 2]} />
					</div>
					<div className="flex--grow w600">
						<p className="with-line margin-m--bottom">Select Year</p>
						<Selector data={[1, 2]} />
					</div>
					<div className="flex--grow w600">
						<p className="with-line margin-m--bottom">Select Month</p>
						<Selector data={[1, 2]} />
					</div>
					<div className="flex--grow w600">
						<p className="with-line margin-m--bottom">Select Week</p>
						<Selector data={[1, 2]} />
					</div>
					<div className="flex--grow w600">
						<p className="with-line margin-m--bottom">Select Format</p>
						<div className="flex gap-m">
							<button className="flex--grow border smooth-corners padding-xs--block">PDF</button>
							<button className="flex--grow border smooth-corners padding-xs--block">Excel</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default SafeTab;
